import { TerminalResponseModel } from "../../app/data/terminal-details/models";

export interface TerminalState {
    data: TerminalResponseModel | null;  
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    errorMessage?: string | null;
}

export const initialTerminalState: TerminalState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
};
  